export function getEditBranchPayload(props: any) {
	const {
		isRestaurant,
		branch,
		getImageValue,
		getCoverValue,
		restaurantImage,
		coverImage,
		customUrl,
		selectedCities,
		isStorePrivate,
		machines,
		parts,
		additionalDetails,
	} = props;
	if (isRestaurant) {
		return {
			name: branch?.name,
			address: branch?.address,
			gstNumber: branch?.gstNumber,
			billingAddress: branch?.billingAddress,
			image: getImageValue(restaurantImage),
			supplier_create_order: branch?.supplier_create_order,
			machines: {
				numberOfMachines: machines.length,
				machines: machines,
			},
			purchasingHabits: parts,
			additionalProfile: additionalDetails,
		};
	}

	if (customUrl?.available) {
		return {
			name: branch?.name,
			address: branch?.address,
			gstNumber: branch?.gstNumber,
			image: getImageValue(restaurantImage),
			cities: selectedCities?.map((city: any) => city?.id),
			cover: getCoverValue(coverImage),
			slug: customUrl?.url,
			private: isStorePrivate,
		};
	}

	return {
		name: branch?.name,
		address: branch?.address,
		gstNumber: branch?.gstNumber,
		image: getImageValue(restaurantImage),
		cities: selectedCities?.map((city: any) => city?.id),
		cover: getCoverValue(coverImage),
		private: isStorePrivate,
	};
}
